import 'core-js/modules/es.object.from-entries'
import 'core-js/modules/es.promise.finally'
import 'core-js/modules/esnext.math.clamp'
import 'core-js/modules/esnext.string.replace-all'

switch (process.env.VITE_WEBSITE) {
  case 'avgen':
    import('./avgen')
    break
  case 'bqpanel':
    import('./bqpanel')
    break
  case 'clipro':
    import('./clipro')
    break
  case 'fast-mamba':
    import('./fast-mamba')
    break
  case 'graphics':
    import('./graphics')
    break
  case 'login':
    import('./login')
    break
  case 'mamba':
    import('./mamba')
    break
  case 'partners-portal':
    import('./partners-portal')
    break
  case 'player':
    import('./player')
    break
  default:
    throw new Error('Invalid website')
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Math {
  clamp: (value: number, min: number, max: number) => number
}
